import { z } from 'zod';

export const Z_TEXT = (minError: string = 'Ce champ est obligatoire.') => z
  .string({ error: minError })
  .min(1, { error: minError });